// extracted by mini-css-extract-plugin
export default {"InputLine":"Profile_InputLine__5X97Y","Center":"Profile_Center__0T1d6"};